export const FIFO_REPORT_LOADING = 'FIFO_REPORT_LOADING';
export const FIFO_REPORT_ITEMS = 'FIFO_REPORT_ITEMS';
export const FIFO_REPORT_LOADING_ERROR = 'FIFO_REPORT_LOADING_ERROR';

export const ON_HAND_REPORT_ITEMS_LOADING = 'ON_HAND_REPORT_ITEMS_LOADING';
export const ON_HAND_REPORT_ITEMS = 'ON_HAND_REPORT_ITEMS';
export const ON_HAND_REPORT_ITEMS_LOADING_ERROR =
  'ON_HAND_REPORT_ITEMS_LOADING_ERROR';

export const ON_HAND_REPORT_SITES_LOADING = 'ON_HAND_REPORT_SITES_LOADING';
export const ON_HAND_REPORT_SITES_DATA = 'ON_HAND_REPORT_SITES_DATA';
export const ON_HAND_REPORT_SITES_LOADING_ERROR =
  'ON_HAND_REPORT_SITES_LOADING_ERROR';
export const RESET_ON_HAND_REPORT_ITEMS_LOADING_ERROR =
  'RESET_ON_HAND_REPORT_ITEMS_LOADING_ERROR';

export const SET_SELECTED_SITES_ITEMS_FOR_FIFO =
  'SET_SELECTED_SITES_ITEMS_FOR_FIFO';

export const TRANSACTION_DETAILS_REPORT_ITEMS =
  'TRANSACTION_DETAILS_REPORT_ITEMS';
export const TRANSACTION_DETAILS_REPORT_LOADING_ERROR =
  'TRANSACTION_DETAILS_REPORT_LOADING_ERROR';
export const TRANSACTION_DETAILS_REPORT_LOADING =
  'TRANSACTION_DETAILS_REPORT_LOADING';
export const RESET_TRANSACTION_DETAILS_LOADING_ERROR =
  'RESET_TRANSACTION_DETAILS_LOADING_ERROR';

export const CLEAR_REPORT_ERROR = 'CLEAR_REPORT_ERROR';

export const SET_FROM_DATE_MAX = 'SET_FROM_DATE_MAX';
export const SET_TO_DATE_MIN = 'SET_TO_DATE_MIN';
export const SET_TRAN_DETAIL_FROM_DATE_MAX = 'SET_TRAN_DETAIL_FROM_DATE_MAX';
export const SET_TRAN_DETAIL_TO_DATE_MIN ='SET_TRAN_DETAIL_TO_DATE_MIN';


// WEBPACK FOOTER //
// ./src/pages/reports/inventory/onhandreport/state/types.js